import { Paper, Typography } from "@mui/material";
import football_img from "../../assets/fallback/image7.jpg";
import styles from "./PartnerWithUs.module.css";

const PartnerWithUs = () => {
  return (
    <div className={styles.container}>
      <div className="main-wrapper">
        <div className="background">
          <img
            src={football_img}
            alt="Footbal"
            loading="lazy"
            decoding="async"
            className="background-image-desktop"
            style={{
              width: "100%",
            }}
          />
        </div>

        <div className="white-paper">
          <Paper
            style={{
              width: "88%",
              position: "relative",
              top: "-15px",
              height: "auto",
              minHeight: "calc(100% + 15px)",
              padding: "20px 32px 20px 32px",
              boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.09)",
            }}
          >
            <Typography
              variant="h5"
              component="h2"
              style={{ color: "#01245a", marginBottom: "20px" }}
            >
              <strong>Partner With Us</strong>
            </Typography>
            <Typography
              variant="body2"
              style={{
                color: "#797979",
                fontSize: "14px",
                textAlign: "justify",
                textAlignLast: "left",
                wordSpacing: "0px",
                letterSpacing: "0.2px",
                lineHeight: "1.6",
                // hyphens: "auto",
              }}
            >
              Build the Future of Sports with WHS Sports Hub
              <br />
              <br />
              WHS Sports Hub partners with schools, colleges, and venues to
              develop world-class sports infrastructure and flexible models that
              empower students and engage communities.
              <br />
              <br />
              Why Partner With Us ?
              <br />
              <span className={styles.tabIndentLarge}>
                • Trusted Expertise in building and managing top-tier sports
                facilities.
              </span>
              <span className={styles.tabIndentLarge}>
                • Flexible Investment Options – Custom-built financial models to
                suit your goals.
              </span>
              <span className={styles.tabIndentLarge}>
                • Student-Centric Development – Fitness, teamwork, and
                leadership.
              </span>
              <span className={styles.tabIndentLarge}>
                • Community Activation – Make your venue a local sports
                destination
              </span>
              <br />
              What We Offer.
              <br />
              <span className={styles.tabIndentLarge}>
                • Multi-Sport Facilities – Football, cricket, pickleball, and
                more.
              </span>
              <span className={styles.tabIndentLarge}>
                • Smart Access System – School use + pay-and-play public model.
              </span>
              <span className={styles.tabIndentLarge}>
                • Online Booking Platform – Seamless scheduling and revenue
                tools
              </span>
              <br />
              Let’s Collaborate!
            </Typography>
          </Paper>
        </div>
        <div className={styles.footer}></div>
      </div>
    </div>
  );
};

export default PartnerWithUs;
